/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EventMetric = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        description: {
    type: 'string',
},
        companyId: {
    type: 'number',
},
        isLeaderOrderDescending: {
    type: 'boolean',
},
        isArchived: {
    type: 'boolean',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
},
    },
};